import React from "react";

import { PropTypes } from "prop-types";
import { useSelector } from "react-redux";
import styled from "styled-components/macro";

import { Button, SecondaryButton, BottomSticky } from "components/Form";
import { Row, Column } from "components/Layout";
import { LotCard } from "components/LotCard";
import { FormModal } from "components/Modal";

import { getNestedConsignments } from "selectors";

const SaleLotsContainer = styled.div`
  width: 100%;
  padding: 6px;
  margin: 0 -6px;
`;

const SaleLotWrapper = styled.div`
  width: 100%;
  margin-top: 12px;
  ${({ theme, selected }) =>
    selected && `box-shadow: 0 0 5px 2px ${theme.colors.ready};`};
`;

const StyledSticky = styled(BottomSticky)`
  background: white;
  margin-top: 1rem;
`;

const AddToLotModal = ({ closeSelf, consignmentId, modalProps }) => {
  const [selected, setSelected] = React.useState(null);
  const saleLots = useSelector(state => {
    const consignments = getNestedConsignments(state);
    const consignment = consignments.find(c => c.id === consignmentId) || {};
    return consignment.saleLots || [];
  });

  const onSubmit = () => {
    const { onNewSaleLotId } = modalProps;
    typeof onNewSaleLotId === "function" && onNewSaleLotId(selected);
    closeSelf();
  };

  return (
    <FormModal
      title="Add EIDs to existing lot"
      contentStyles={{ margin: "0 24px", maxHeight: "100%" }}
      closeSelf={closeSelf}
    >
      <Column>
        <SaleLotsContainer>
          {saleLots.map(lot => (
            <SaleLotWrapper key={lot.id} selected={selected === lot.id}>
              <LotCard
                onClickCard={() => {
                  setSelected(lot.id);
                }}
                showActions={false}
                saleLot={lot}
                showScanning
                showPen
              />
            </SaleLotWrapper>
          ))}
        </SaleLotsContainer>
      </Column>
      <StyledSticky>
        <Row>
          <SecondaryButton onClick={closeSelf}>Cancel</SecondaryButton>
          <Button
            data-tour="addToLot"
            onClick={onSubmit}
            disabled={selected === null}
          >
            Add to Lot
          </Button>
        </Row>
      </StyledSticky>
    </FormModal>
  );
};

AddToLotModal.propTypes = {
  closeSelf: PropTypes.func.isRequired,
  consignmentId: PropTypes.string,
  modalProps: PropTypes.object.isRequired,
};

export default AddToLotModal;
